module.exports = __webpack_public_path__ + "static/media/flipfoot.bad53eaf.jpg";